import { render, staticRenderFns } from "./sequence-review-signature.vue?vue&type=template&id=f2475db4&scoped=true&"
import script from "./sequence-review-signature.vue?vue&type=script&lang=js&"
export * from "./sequence-review-signature.vue?vue&type=script&lang=js&"
import style0 from "./sequence-review-signature.vue?vue&type=style&index=0&id=f2475db4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2475db4",
  null
  
)

export default component.exports